import { gql } from '@apollo/client';
import { client } from 'src/index';
import viewStateVar from 'src/store/viewState';
import type { ViewStateUpdate } from 'src/types/store.types';

export const setGlobalState = (state: ViewStateUpdate): void => {
  viewStateVar({
    ...viewStateVar(),
    ...state,
  });
};

const initializeLocalState = (): void => {
  client.writeQuery({
    query: gql`
      query initializeViewState {
        viewState {
          initialViewState
        }
      }
    `,
    data: {
      viewState: {
        initialViewState: viewStateVar(),
      },
    },
  });
};

type OnChangeFunction = (name: string, val: string | undefined) => void;

class CustomURLSearchParams extends URLSearchParams {
  private _onChangeFunctions: OnChangeFunction[];

  constructor() {
    super(window.location.search);
    this._onChangeFunctions = [];
  }

  override set(a: string, b: string): void {
    super.set(a, b);
    // DISABLED: setToURL() bypasses TanStack Router and causes URL state corruption (akomi-ea6)
    // TanStack Router should be the only system managing URL state
    // this.setToURL();
    this._triggerOnChange(a, b);

    if (b === undefined || b === '') {
      this.delete(a);
    }
  }

  /**
   * @deprecated This method is disabled. TanStack Router manages URL state.
   * Direct window.history manipulation conflicts with router state management.
   */
  setToURL(): void {
    // DISABLED: This was causing URL state corruption (akomi-ea6)
    // TanStack Router should be the only system managing URL state
    // window.history.replaceState(null, '', `?${super.toString()}`);
    console.warn('CustomURLSearchParams.setToURL() is deprecated - use TanStack Router navigate() instead');
  }

  override delete(a: string): void {
    super.delete(a);
    // DISABLED: setToURL() bypasses TanStack Router
    // this.setToURL();
  }

  override append(a: string, b: string): void {
    super.append(a, b);
    // DISABLED: setToURL() bypasses TanStack Router
    // this.setToURL();
    this._triggerOnChange(a, b);
    if (b === undefined || b === '') {
      this.delete(a);
    }
  }

  private _triggerOnChange(name: string, val: string): void {
    this._onChangeFunctions.forEach((fn) => {
      fn(name, val);
    });
  }

  onChange(fn: OnChangeFunction): void {
    this._onChangeFunctions = [...this._onChangeFunctions, fn];
  }
}

export { CustomURLSearchParams, initializeLocalState };
